// extracted by mini-css-extract-plugin
module.exports = {"cards":"Home_cards__j9bHa"};